// ref: https://gist.github.com/codeguy/6684588#gistcomment-3426313

import { nanoid } from "nanoid";
import { Note } from "../notes-list.imba";

export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(" ");

  return value
    .normalize("NFD") // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, "-"); // separator
};

export function getSelectedText(): Selection {
  var selectedText: Selection;

  // window.getSelection
  if (window.getSelection) {
    selectedText = window.getSelection();
  }
  return selectedText;
}

export let newNote = (): Note => ({
  id: nanoid(),
  title: "A Simple Note",
  selected: true,
  data: "Start writing...",
  date: new Date().toDateString() + " @ " + time(),
});

function time(): string {
  const date = new Date();
  const h = date.getHours();
  const hour = h > 12 ? h - 12 : h;
  const sec = date.getSeconds();
  const secs = sec < 10 ? "0" + sec : sec;
  const min = date.getMinutes();
  const mins = min < 10 ? "0" + min : min;
  const ampm = h >= 12 ? "pm" : "am";
  return hour + ":" + mins + ":" + secs + " " + ampm;
}

// in component
// # def selectText
// # 	let selectionNode = getSelectedText()
// # 	let selectedText = selectionNode.focusNode.nodeValue.slice(selectionNode.anchorOffset, selectionNode.focusOffset)
// # 	console.log selectedText
